module.exports = __webpack_public_path__ + "img/3057f56.png";